// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__dX_bp","selectElement":"Select_selectElement__a5fpX","selectLoader":"Select_selectLoader__v6UsQ"};